// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

// Ensure the element with id 'root' exists in public/index.html
const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);
root.render(<App />);